const frameRateTracking = {
    minSampleTime: 1000, // Capture frames for at least this many milliseconds before determining average
    fpsMinAcceptable: 35, // Min acceptable average frame rate
    frameRenderTimes: [],
    averageFps: null,
};

export function resetFrameRateTracking () {
    // Interrupting continuous rendering so nullify frame rate tracking
    frameRateTracking.frameRenderTimes = [];
}
export function updateFrameRateTracking () {
    // No point tracking frame rates further
    if (window.jmAppState.parralaxKilled) return;

    // Push a new timestamp to render times
    frameRateTracking.frameRenderTimes.push(Date.now());

    // Calculate average fps
    updateAverageFps();

    // Kill parralax if frame rate is too low
    if (!window.jmAppState.killParralax) {
        window.jmAppState.killParralax =
        frameRateTracking.averageFps !== null && frameRateTracking.averageFps < frameRateTracking.fpsMinAcceptable;
    }

}
export function updateAverageFps () {
    // Debugging (use watch expression)
    // window.jmAppState.frameRateTracking = frameRateTracking;

    const expiry = Date.now() - frameRateTracking.minSampleTime;

    // Return false if sample range not big/long enough
    if (frameRateTracking.frameRenderTimes.length < 5 || frameRateTracking.frameRenderTimes[0] > expiry) {
        return false;
    }

    // Calculate FPS per frame
    const fpsArray = [];
    for (const [i, timestamp] of frameRateTracking.frameRenderTimes.entries()) {
        if (i === 0) {
            continue;
        }
        const renderTime = timestamp - frameRateTracking.frameRenderTimes[i - 1];
        const fps = 1000 / renderTime;
        fpsArray.push(fps);
    }

    // Sort and remove slowest frame as outlier
    fpsArray.sort((a, b) => a - b).shift();

    // Calculate average
    frameRateTracking.averageFps = fpsArray.reduce((previous, current) => current += previous) / fpsArray.length;

    // Trim sample range
    frameRateTracking.frameRenderTimes = frameRateTracking.frameRenderTimes.filter(timestamp => timestamp >= expiry);
}
export function killParralax () {
    document.documentElement.classList.remove('parralax');
    window.jmAppState.parralaxKilled = true;
    ga('send', 'event', 'performance', 'parralax killed', window.jmAppState.averageFps);
}

// Scrolljacking test element
let circle = false;
const initTestAnimation = () => {
    circle = document.createElement('div');
    circle.style.cssText = 'border-radius: 50%; width: 5vmin; height: 5vmin; background: lime; position: fixed; left: 0; top: 5vh; z-index: 10;';
    document.body.appendChild(circle);
}
export function testAnimation () {
    if (!circle) {
        initTestAnimation();
    }
    const circleWidth = circle.clientWidth;
    const pos = window.jmAppState.scrollTop / (window.jmAppState.pageHeight - window.jmAppState.windowHeight);
    const scale = pos * .2 + 1;
    circle.style.transform = `translate(${pos * (window.jmAppState.windowWidth - circleWidth)}px, 0) scale(${scale})`;
}